module.exports = __webpack_public_path__ + "static/media/giaCore-logo2.26f74f96.png";